// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

import type { ActorModelType } from './Actor';

type GeocodingProviderEnum =
    | 'CLIENT_READ'
    | 'CLIENT_GEOCODER'
    | 'LOCUS_GEOCODER';
type GeocodingGoodnessEnum = 'HIGH' | 'LOW';
type GeocodingConfidenceEnum = 'HIGH' | 'MEDIUM' | 'LOW';

export type GeocodingMetadataModelType = {
    provider: GeocodingProviderEnum,
    goodness: GeocodingGoodnessEnum,
    confidence: GeocodingConfidenceEnum,
    verified: boolean,
    verifiedBy: ?ActorModelType,
    verifiedAt: ?string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class GeocodingMetadata extends ImmutableModel {
    static fromJS(json: GeocodingMetadataModelType): GeocodingMetadata {
        const state: Object = Object.assign({}, json);
        state.verifiedBy = state.verifiedBy
            ? Actor.fromJS(state.verifiedBy)
            : state.verifiedBy;
        return new this(Immutable.Map(state));
    }

    toJS(): GeocodingMetadataModelType {
        return {
            provider: this.provider,
            goodness: this.goodness,
            confidence: this.confidence,
            verified: this.verified,
            verifiedBy: this.verifiedBy
                ? this.verifiedBy.toJS()
                : this.verifiedBy,
            verifiedAt: this.verifiedAt
        };
    }

    get provider(): GeocodingProviderEnum {
        return this._state.get('provider');
    }

    setProvider(provider: GeocodingProviderEnum): this {
        return this.clone(this._state.set('provider', provider));
    }

    get goodness(): GeocodingGoodnessEnum {
        return this._state.get('goodness');
    }

    setGoodness(goodness: GeocodingGoodnessEnum): this {
        return this.clone(this._state.set('goodness', goodness));
    }

    get confidence(): GeocodingConfidenceEnum {
        return this._state.get('confidence');
    }

    setConfidence(confidence: GeocodingConfidenceEnum): this {
        return this.clone(this._state.set('confidence', confidence));
    }

    get verified(): boolean {
        return this._state.get('verified');
    }

    setVerified(verified: boolean): this {
        return this.clone(this._state.set('verified', verified));
    }

    get verifiedBy(): ?Actor {
        return this._state.get('verifiedBy');
    }

    setVerifiedBy(verifiedBy: ?Actor): this {
        return this.clone(this._state.set('verifiedBy', verifiedBy));
    }

    get verifiedAt(): ?string {
        return this._state.get('verifiedAt');
    }

    setVerifiedAt(verifiedAt: ?string): this {
        return this.clone(this._state.set('verifiedAt', verifiedAt));
    }
}
